import { PrefetchResult, usePrefetch } from "@jog/react-components"
import { fetchS3Pdp, prismicClient, retry, transPdp } from "@jog/shared"
import { GetStaticPropsContext } from "next"

import type { PdpDocument } from "../prismicio/types.generated"

export function prefetchSimplePdp(prefetch: PrefetchResult["prefetch"]) {
    return prefetch("pdp", async (pageContext?: GetStaticPropsContext) => {
        const { desktopSortingByName, mobileSortingByName, faslet } = await retry(() =>
            pageContext?.previewData
                ? prismicClient({ previewData: pageContext.previewData }).getSingle("pdp")
                : fetchS3Pdp<PdpDocument>()
        ).then((res) => transPdp(res.data))
        return { desktopSortingByName, mobileSortingByName, faslet }
    })
}

export const useSimplePdp = () => {
    const { data } = usePrefetch("pdp")
    return data
}
